import IndexPage from '@dex/bubl-dash/src/lib/pages/IndexPage';
import NewsCreateEditForm from './Components/NewsCreateEditForm';
import NewsApi from './NewsApi';

export default function (app, settings) {

    app.addRoute({
        name: settings.key + "New",
        zone: settings.zone,
        path: settings.key + "/create",
        caps: settings.createCaps,
        component: IndexPage,
        componentProps: {
            header: {
                getTitle: () => "Add New",
                getButtons: settings.indexButtons,
                getTabs: settings.indexTabs,
                getTabCounts: settings.indexTabCounts,
            },
            create: {
                form: NewsCreateEditForm,
                getCreate: NewsApi.create,
                defaults: {
                    contentBlocks:[], 
                    video:{id:'', source: ''},
                    status:'draft',
                    type:'news',
                },
                successMessage: "News Saved",
                successRouteName: settings.key + "View",
                idKey: settings.idKey
            }
        },
    });

}